export const builderSamplePrompts = [
  {
    label: "Skincare Overview",
    fullPrompt: "Provide an overview of skincare",
  },
  {
    label: "Makeup Trends on TikTok France",
    fullPrompt: "What are the top trends in makeup on TikTok in France?",
  },
  {
    label: "Beauty Brands",
    fullPrompt: "What are the top brands in beauty?",
  },
  {
    label: "Face Serum vs. Moisturizer",
    fullPrompt: "Compare face serum vs face moisturizer in the US",
  },
];
